import { Integration } from '../graphql'

export const INTEGRATIONS_TO_EXCLUDE = [
	'Caterpillar VisionLink (deprecated authentication)',
	'CASE Sitewatch',
]

export const filterIntegrations = ( integrations: Integration[] ): Integration[] => {
	return integrations
		.filter( ( integration ) => integration.isActive && !INTEGRATIONS_TO_EXCLUDE.includes( integration.name ) )
}
